import { createNamespace } from '../utils';

var _createNamespace = createNamespace('guide'),
    createComponent = _createNamespace[0],
    bem = _createNamespace[1];

export default createComponent({
  props: {
    imgList: {
      type: Array,
      default: []
    }
  },
  data: function data() {
    return {
      step: 0
    };
  },
  watch: {
    step: function step() {
      if (this.step > this.imgList.length - 1) {
        this.$emit('end');
      }
    }
  },
  computed: {
    backgroundStyle: function backgroundStyle() {
      return {
        background: "url(" + this.imgList[this.step] + ") fixed 0 0/cover"
      };
    }
  },
  render: function render() {
    var _this = this;

    var h = arguments[0];
    return h("div", {
      "attrs": {
        "role": "guide"
      },
      "class": bem(),
      "on": {
        "click": function click() {
          _this.step++;
        }
      },
      "style": this.backgroundStyle
    });
  }
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/vant-green/es/guide/index.js
// module id = null
// module chunks = 